import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';
import apiSearch from '@/api/get/searchMultiResults';
import { useSearchContext } from '../../context/search';

// api

export default () => {
  const [state, { setFilters }] = useSearchContext();
  const { activeTab, query, searchType, hasLoadMore, updateHistory } = state;
  useEffect(() => {
    if (!query.value) return;
    const successCB = ({ filters, html }) => {
      if (filters) setFilters(filters);
      if (updateHistory) {
        window.history.pushState(state, null, query.url);
      }
      DLG.EVE.emit(EVENTS.SEARCH.RESULTS.UPDATE, {
        id: activeTab.id,
        searchType,
        html,
      });
      DLG.EVE.emit(EVENTS.LISTING.COMPARE.CLEAR);
    };

    apiSearch({
      query: query.value,
      sort: query.sort,
      searchType,
      hasLoadMore,
      successCB,
    });
  }, [query]);
};
